const activeMaintenanceValue = (maintenance) => {
    let value;
    if (maintenance) {
        Object.keys(maintenance)?.forEach((item) => {
            if (maintenance[item]?.qty === 1) {
                value = item;
            }
        });
    }
    if (!value) value = 0;

    if (value === 'lifetime') {
        // ok
    } else if ((value === 0) || (value === '0')) {
        value = 0;
    } else if ((value === 1) || (value === '1')) {
        value = 1;
    } else if ((value === 3) || (value === '3')) {
        value = 3;
    }

    return value;
};

export {activeMaintenanceValue};
